module.exports = __webpack_public_path__ + "img/Slice124.f316c60e.png";